export default "__VITE_ASSET__BGqDbHk4__"